exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] #page-login .social-login-buttons .bg-facebook{background-color:#1551b1}[dir] #page-login .social-login-buttons .bg-twitter{background-color:#0af}[dir] #page-login .social-login-buttons .bg-google{background-color:#4285f4}[dir] #page-login .social-login-buttons .bg-github{background-color:#333}[dir] #page-login .bg-blue{background-color:#0af}", ""]);

// exports
